import React, { Component } from "react";
import FlickSlider from "../FlickSlider/FlickSlider";
import HoverLink from "../HoverLink/HoverLink";
import { Link } from "react-router-dom";
import ProjectList from "../ProjectList/ProjectList";

import "../../App.css";
import { ProjectsContext } from "../../ProjectsContext";

class HomePage extends Component {
  constructor(props) {
    super(props);
    // this.random = Math.floor(Math.random() * 2);
    this.random = 1;
    this.state = { isVisible: false };
    this.setTimeout = null;
  }

  static contextType = ProjectsContext;

  componentDidMount() {
    this.setState({ isVisible: !this.state.isVisible });
    setTimeout(() => this.styleBlack(), 1000);

    this.homeData = this.context.slider.acf;

    this.featuredTicking = false;
    this.statementArmed = false;
    this.featuredScrollListener = this.handleFeaturedScroll;
    // Listening from the off: the old 2s delay was harmless for a one-shot
    // reveal, but a scroll that lands inside it would leave the fill frozen at
    // whatever it was when the page loaded.
    document.addEventListener("scroll", this.featuredScrollListener, {
      passive: true,
    });
    this.updateStatementFill();
    // The statement arrives with the WP fetch, so set the fill once more after
    // there is something to measure.
    setTimeout(() => this.updateStatementFill(), 1000);
  }

  styleBlack = () => {
    document.querySelector("header").classList.add("black-bg");
  };

  // rAF-throttled, and unlike the old one-shot reveal this keeps listening —
  // the fill is a function of where the text sits, so scrolling back up has to
  // unwind it.
  handleFeaturedScroll = () => {
    if (!this.featuredTicking) {
      window.requestAnimationFrame(() => {
        this.updateStatementFill();
        this.featuredTicking = false;
      });
      this.featuredTicking = true;
    }
  };

  // Sweeps the statement from grey to black as it rises through the viewport.
  // Progress runs 0 to 1 while the text's top travels from 80% to 20% of the
  // viewport height, and scales a gradient that App.css clips to the glyphs.
  // The gradient is twice the text's width with its black stop at the halfway
  // mark, so the fill only completes once the box has grown to 200%.
  updateStatementFill = () => {
    const el = document.querySelector(".featured-header h1 span");
    if (!el) return;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const top = el.getBoundingClientRect().top;
    // Only run the sweep for text that actually scrolls in from below. On
    // phones the statement is already on screen at rest, and there is no
    // scroll left to finish a fill it started part-way through, so it would
    // sit there permanently half-drawn. Show it whole instead.
    if (top >= vh) this.statementArmed = true;
    const progress = this.statementArmed
      ? Math.min(Math.max((vh * 0.8 - top) / (vh * 0.6), 0), 1)
      : 1;
    el.style.backgroundSize = `${progress * 200}% 100%`;
  };

  componentWillUnmount() {
    document.querySelector("header").classList.remove("black-bg");
    window.clearTimeout(this.timeout);
    document.removeEventListener("scroll", this.featuredScrollListener, {
      passive: true,
    });
  }

  render() {
    return (
      <div className="home transition-page">
        <FlickSlider />
        <div className="featured-header">
          <div className="container">
            <h1 className="reg">
              <span>{this.homeData?.featured_projects_header}</span>
            </h1>
          </div>
        </div>
        <ProjectList />
      </div>
    );
  }
}

export default HomePage;
